import Parse from 'html-react-parser';

function BMP20197(props) {
    let svgCode =
    `<svg width="252" height="264" viewBox="0 0 252 264" fill="none" xmlns="http://www.w3.org/2000/svg">
    <style type="text/css">
    .radiation {
        ${props.radiation}
    }
    </style>
        <path class="radiation" d="M6.5 22C6.5 22 11 48.5 19.5 22C28 -4.5 33.5 22 33.5 22" stroke="${props.highlightColour}" stroke-width="3"/>
        <path d="M90 34.5L104 12L118 34.5" stroke="${props.darkFill}" stroke-width="3"/>
        <path d="M133 21.5L145.5 32V11.5L159 21.5" stroke="${props.darkFill}" stroke-width="3"/>
        <path d="M174.5 22V33.5H187.5V10.5H201.5V22" stroke="${props.darkFill}" stroke-width="3"/>
        <path d="M216.5 22V33.5H224.5V10.5H243.5V22" stroke="${props.darkFill}" stroke-width="3"/>
        <path d="M48.5 22C48.5 23 47.5 34.5 55 34.5C62.5 34.5 62 23 62 22C62 21 61.5 10.5 69 10.5C76.5 10.5 75.5 21 75.5 22" stroke="${props.darkFill}" stroke-width="3"/>
        <path d="M6 65.7778C6 65.7778 10.5 92.2778 19 65.7778C27.5 39.2778 33 65.7778 33 65.7778" stroke="${props.darkFill}" stroke-width="3"/>
        <path d="M89.5 78.2778L103.5 55.7778L117.5 78.2778" stroke="${props.darkFill}" stroke-width="3"/>
        <path d="M132.5 65.2778L145 75.7778V55.2778L158.5 65.2778" stroke="${props.darkFill}" stroke-width="3"/>
        <path d="M174 65.7778V77.2778H187V54.2778H201V65.7778" stroke="${props.darkFill}" stroke-width="3"/>
        <path d="M216 65.7778V77.2778H224V54.2778H243V65.7778" stroke="${props.darkFill}" stroke-width="3"/>
        <path class="radiation" d="M48 65.7778C48 66.7778 47 78.2778 54.5 78.2778C62 78.2778 61.5 66.7777 61.5 65.7778C61.5 64.7778 61 54.2778 68.5 54.2778C76 54.2778 75 64.7778 75 65.7778" stroke="${props.highlightColour}" stroke-width="3"/>
        <path d="M6 109.778C6 109.778 10.5 136.278 19 109.778C27.5 83.2778 33 109.778 33 109.778" stroke="${props.darkFill}" stroke-width="3"/>
        <path class="radiation" d="M89.5 122.278L103.5 99.7778L117.5 122.278" stroke="${props.highlightColour}" stroke-width="3"/>
        <path d="M132.5 109.278L145 119.778V99.2778L158.5 109.278" stroke="${props.darkFill}" stroke-width="3"/>
        <path d="M174 109.778V121.278H187V98.2778H201V109.778" stroke="${props.darkFill}" stroke-width="3"/>
        <path d="M216 109.778V121.278H224V98.2778H243V109.778" stroke="${props.darkFill}" stroke-width="3"/>
        <path d="M48 109.778C48 110.778 47 122.278 54.5 122.278C62 122.278 61.5 110.778 61.5 109.778C61.5 108.778 61 98.2778 68.5 98.2778C76 98.2778 75 108.778 75 109.778" stroke="${props.darkFill}" stroke-width="3"/>
        <path d="M6 153.778C6 153.778 10.5 180.278 19 153.778C27.5 127.278 33 153.778 33 153.778" stroke="${props.darkFill}" stroke-width="3"/>
        <path d="M89.5 166.278L103.5 143.778L117.5 166.278" stroke="${props.darkFill}" stroke-width="3"/>
        <path class="radiation" d="M132.5 153.278L145 163.778V143.278L158.5 153.278" stroke="${props.highlightColour}" stroke-width="3"/>
        <path d="M174 153.778V165.278H187V142.278H201V153.778" stroke="${props.darkFill}" stroke-width="3"/>
        <path d="M216 153.778V165.278H224V142.278H243V153.778" stroke="${props.darkFill}" stroke-width="3"/>
        <path d="M48 153.778C48 154.778 47 166.278 54.5 166.278C62 166.278 61.5 154.778 61.5 153.778C61.5 152.778 61 142.278 68.5 142.278C76 142.278 75 152.778 75 153.778" stroke="${props.darkFill}" stroke-width="3"/>
        <path d="M6 197.778C6 197.778 10.5 224.278 19 197.778C27.5 171.278 33 197.778 33 197.778" stroke="${props.darkFill}" stroke-width="3"/>
        <path d="M89.5 210.278L103.5 187.778L117.5 210.278" stroke="${props.darkFill}" stroke-width="3"/>
        <path d="M132.5 197.278L145 207.778V187.278L158.5 197.278" stroke="${props.darkFill}" stroke-width="3"/>
        <path class="radiation" d="M174 197.778V209.278H187V186.278H201V197.778" stroke="${props.highlightColour}" stroke-width="3"/>
        <path d="M216 197.778V209.278H224V186.278H243V197.778" stroke="${props.darkFill}" stroke-width="3"/>
        <path d="M48 197.778C48 198.778 47 210.278 54.5 210.278C62 210.278 61.5 198.778 61.5 197.778C61.5 196.778 61 186.278 68.5 186.278C76 186.278 75 196.778 75 197.778" stroke="${props.darkFill}" stroke-width="3"/>
        <path d="M6 241.778C6 241.778 10.5 268.278 19 241.778C27.5 215.278 33 241.778 33 241.778" stroke="${props.darkFill}" stroke-width="3"/>
        <path d="M89.5 254.278L103.5 231.778L117.5 254.278" stroke="${props.darkFill}" stroke-width="3"/>
        <path d="M132.5 241.278L145 251.778V231.278L158.5 241.278" stroke="${props.darkFill}" stroke-width="3"/>
        <path d="M174 241.778V253.278H187V230.278H201V241.778" stroke="${props.darkFill}" stroke-width="3"/>
        <path class="radiation" d="M216 241.778V253.278H224V230.278H243V241.778" stroke="${props.highlightColour}" stroke-width="3"/>
        <path d="M48 241.778C48 242.778 47 254.278 54.5 254.278C62 254.278 61.5 242.778 61.5 241.778C61.5 240.778 61 230.278 68.5 230.278C76 230.278 75 240.778 75 241.778" stroke="${props.darkFill}" stroke-width="3"/>
    </svg>`

    props.svgReturn(76, svgCode, "bmp00197", 252, 264);

    const style = {
        position: "absolute",
        overflow: "hidden",
        height: "50px",
        top: "200px",
        left: "27px",
        display: props.display
    }

    const inStyle = {
        marginTop: "0px"
    }

    return (
        <div style={style}>
            <div style={inStyle}>
            {Parse(svgCode)}
            </div>
        </div>
    );
}

export default BMP20197;